import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { LogIn } from 'lucide-react';

const Login = () => {
  return (
    <>
      {/* ── noindex: private login page — must never appear in Google search ── */}
      <Helmet>
        <title>Login | Yashoda Total Solution</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
      </Helmet>

      <div className="min-h-screen bg-[#F5F7F9]">
        {/* Hero Section */}
        <section className="relative overflow-hidden bg-gradient-to-br from-[#0F7A4A] via-[#0A5734] to-[#0F7A4A] text-white py-20 md:py-32">
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 z-10">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-center"
            >
              <div
                className="inline-flex items-center justify-center w-20 h-20 bg-[#F39C12] rounded-full mb-6"
                aria-hidden="true"
              >
                <LogIn className="h-10 w-10 text-white" aria-hidden="true" />
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
                Login
              </h1>
              <p className="text-lg md:text-xl text-white/90">
                Access your account
              </p>
            </motion.div>
          </div>
        </section>

        {/* Placeholder Content */}
        <section className="py-16 md:py-24">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <p className="text-xl text-[#52606D]">
              Login page will be added soon.
            </p>
          </div>
        </section>
      </div>
    </>
  );
};

export default Login;